export let TotalStudyStatusListColumn = /*#__PURE__*/function (TotalStudyStatusListColumn) {
  TotalStudyStatusListColumn["STUDENT"] = "studentName";
  TotalStudyStatusListColumn["TEACHER"] = "teacherName";
  TotalStudyStatusListColumn["MATERIAL_COURSE"] = "materialCourse";
  TotalStudyStatusListColumn["ASSIGNMENT_TYPE"] = "assignmentType";
  TotalStudyStatusListColumn["MISSION_TITLE"] = "missionTitle";
  TotalStudyStatusListColumn["PROBLEM_NUMBER"] = "problemNumber";
  TotalStudyStatusListColumn["STUDY_STEP"] = "studyStatusType";
  TotalStudyStatusListColumn["IS_DESCRIPTIVE"] = "isDescriptive";
  TotalStudyStatusListColumn["SOLVING_RESULT"] = "solvingResult";
  TotalStudyStatusListColumn["RUBRIC_GRADE_OVERALL_RESULT"] = "rubricGradeOverallResult";
  TotalStudyStatusListColumn["QUESTION"] = "question";
  TotalStudyStatusListColumn["FEEDBACK_CHECK_STATUS"] = "feedbackCheckStatus";
  TotalStudyStatusListColumn["IS_ANOMALOUS"] = "isAnomalous";
  TotalStudyStatusListColumn["SOLVED_AT"] = "solvedAt";
  return TotalStudyStatusListColumn;
}({});
export let CheckStatus = /*#__PURE__*/function (CheckStatus) {
  CheckStatus["ACTION_COMPLETED"] = "ACTION_COMPLETED";
  CheckStatus["CHECKED"] = "CHECKED";
  CheckStatus["NOT_CHECKED"] = "NOT_CHECKED";
  CheckStatus["REVIEW_NEEDED"] = "REVIEW_NEEDED";
  return CheckStatus;
}({});
export let QuestionStatus = /*#__PURE__*/function (QuestionStatus) {
  QuestionStatus["COMPLETE"] = "COMPLETE";
  QuestionStatus["PENDING"] = "PENDING";
  QuestionStatus["NONE"] = "NONE";
  return QuestionStatus;
}({});
export let StudyStatus = /*#__PURE__*/function (StudyStatus) {
  StudyStatus["ACTIVE"] = "ACTIVE";
  StudyStatus["INACTIVE"] = "INACTIVE";
  StudyStatus["WARNING"] = "WARNING";
  return StudyStatus;
}({});